import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Link as MuiLink, Tooltip, IconButton, Divider } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import DeleteIcon from '@mui/icons-material/Delete';

import GlassCard from '../../../ui/glass/components/GlassCard';
import usePermissions from '../../../hooks/usePermissions';

const formatCurrency = (amount) => (amount ?? 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
const formatDate = (timestamp) => timestamp ? timestamp.toDate().toLocaleDateString('tr-TR') : '---';

const AccountStatementTable = ({ allMovements, handleDeleteTransaction }) => {
    const { canDelete } = usePermissions();
    return (
        <GlassCard sx={{ p: 3, mb: 3 }}>
            <Divider />
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Tarih</TableCell>
                            <TableCell sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Açıklama</TableCell>
                            <TableCell align="right" sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Borç</TableCell>
                            <TableCell align="right" sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Alacak</TableCell>
                            <TableCell align="right" sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>Bakiye</TableCell>
                            <TableCell className="no-print" sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>İşlem</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allMovements.map((m, index) => (
                            <TableRow key={index} hover sx={{ transition: 'background-color 0.2s' }}>
                                <TableCell>{formatDate(m.date)}</TableCell>
                                <TableCell>
                                    {m.isServiceRecord ? (
                                        <MuiLink component={RouterLink} to={`/servis-kaydi/${m.refId}`} sx={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                                            {m.description} <LaunchIcon fontSize="small" sx={{ ml: 0.5 }} />
                                        </MuiLink>
                                    ) : (m.description)}
                                </TableCell>
                                <TableCell align="right" sx={{ color: 'error.main' }}>{m.type === 'borc' ? formatCurrency(m.amount) : '-'}</TableCell>
                                <TableCell align="right" sx={{ color: 'success.main' }}>{m.type === 'alacak' ? formatCurrency(m.amount) : '-'}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(m.balance)}</TableCell>
                                <TableCell className="no-print">
                                    {!m.isServiceRecord && canDelete() && (
                                        <Tooltip title="Bu işlemi sil">
                                            <IconButton size="small" onClick={() => handleDeleteTransaction(m.transactionData || { id: m.refId, type: m.type, amount: m.amount })}>
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </GlassCard>
    );
};

export default AccountStatementTable;
